import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA,
  GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT,
  GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND,
  GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK,
  GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR,
} from '../../../../../../constants/GuestRoomExperienceConst';
import { Button } from '@material-ui/core';
import GuestRoomExperienceGlobalTabDefault from '../../../../../../components/guest-room-experience-global-tabs/guest-room-experience-global-tab-default/Guest-Room-Experience-Global-Tab-Default';
import GuestRoomExperienceGlobalTabDND from '../../../../../../components/guest-room-experience-global-tabs/guest-room-experience-global-tab-dnd/Guest-Room-Experience-Global-Tab-DND';
import GuestRoomExperienceGlobalTabMMR from '../../../../../../components/guest-room-experience-global-tabs/guest-room-experience-global-tab-mmr/Guest-Room-Experience-Global-Tab-MMR';
import GuestRoomExperienceGlobalTabDoorLock from '../../../../../../components/guest-room-experience-global-tabs/guest-room-experience-global-tab-door-lock/Guest-Room-Experience-Global-Tab-Door-Lock';
import { useDispatch, useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../../../../property/propertySlice';
import { useHistory } from 'react-router-dom';
import { fetchAllGREGlobalConfigs } from '../../../../configurationSlice';
import GuestRoomExperienceGlobalTabDoorCamera from '../../../../../../components/guest-room-experience-global-tabs/guest-room-experience-global-tab-door-camera/Guest-Room-Experience-Global-Tab-Door-Camera';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    // color: "#29E67C",
    margin: '5px !important',
    borderRadius: '5px !important',
    borderBottom: '4px solid #74E287',
    opacity: 1,
    minWidth: '100px',
    fontWeight: 500,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  button: {
    border: '1px solid #999999',
    margin: '5px !important',
    borderRadius: '5px !important',
    minWidth: '100px',
    fontWeight: 500,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  input: {
    display: 'none',
  },
}));

const GuestRoomExperienceGlobal = (props) => {
  const { showLoader = () => {} } = props;
  const [activeTab, setActiveTab] = useState(GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT);
  const classes = useStyles();
  const selectedHotel = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllGREGlobalConfigs(selectedHotel));
    }
  }, [selectedHotel, dispatch]);

  return (
    <>
      <div className='row d-flex mt-4 guest-room-list mx-3 mb-3'>
        <div className='d-flex flex-wrap'>
          <Button
            size='large'
            variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT ? 'outlined' : 'text'}
            className={
              activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT
                ? classes.activeButton
                : classes.button
            }
            onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT)}
          >
            Default
          </Button>
          <Button
            size='large'
            variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND ? 'outlined' : 'text'}
            className={
              activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND
                ? classes.activeButton
                : classes.button
            }
            onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND)}
          >
            DND
          </Button>
          <Button
            size='large'
            variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR ? 'outlined' : 'text'}
            className={
              activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR
                ? classes.activeButton
                : classes.button
            }
            onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR)}
          >
            MMR
          </Button>
          <Button
            size='large'
            variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK ? 'outlined' : 'text'}
            className={
              activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK
                ? classes.activeButton
                : classes.button
            }
            onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK)}
            style={{ width: '180px' }}
          >
            Digital Door Key
          </Button>
          <Button
            size='large'
            variant={activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA ? 'outlined' : 'text'}
            className={
              activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA
                ? classes.activeButton
                : classes.button
            }
            onClick={() => setActiveTab(GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA)}
            style={{ width: '150px' }}
          >
            Door Camera
          </Button>
        </div>
      </div>
      <div className='row mx-2 d-flex mt-2 h-100'>
        {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DEFAULT && (
          <GuestRoomExperienceGlobalTabDefault
            selectedHotel={selectedHotel}
            showLoader={showLoader}
          />
        )}
        {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DND && (
          <GuestRoomExperienceGlobalTabDND selectedHotel={selectedHotel} showLoader={showLoader} />
        )}
        {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_MMR && (
          <GuestRoomExperienceGlobalTabMMR selectedHotel={selectedHotel} showLoader={showLoader} />
        )}
        {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_TAB_DOOR_LOCK && (
          <GuestRoomExperienceGlobalTabDoorLock
            selectedHotel={selectedHotel}
            showLoader={showLoader}
          />
        )}
        {activeTab === GUEST_ROOM_EXPERIENCE_GLOBAL_DOOR_CAMERA && (
          <GuestRoomExperienceGlobalTabDoorCamera
            selectedHotel={selectedHotel}
            showLoader={showLoader}
          />
        )}
      </div>
    </>
  );
};

export default GuestRoomExperienceGlobal;
